module.exports = "/_next/static/images/hero-bg-light-afa95ff3ef6acd587a1dfda568c0039c.png.webp";